import React, {
  useState,
  useEffect,
  useContext,
  useRef,
  useCallback,
} from "react";
import DatePicker from "react-datepicker";
import Select from "../common/selectcustom";
import { Button } from "bootstrap";
//import ChartColumn from './../../components/chart/column';
import ProgressChart from "../chart/progresschart.js";
import ReportCreate from "../chart/reportCreator";
import Piechart from "../chart/piechart.js";
import moment from "moment";
import RenderButton from "../common/button";
import BranchContext from "../context/branch";
import {
  GetYear,
  getReportgroup,
  ReportData,
  GetLocationAll,
  getProductgroup,
  getItems,
  getAreaZoneSelect,
  toexcelreportcheck,
  getreportcheck,
} from "../../services/fire";
import { getMonth } from "../../services/month";
import ScrollToTop from "../common/ScrollToTop";
import Renderreport from "./renderreport";
import { toast } from "react-toastify";
import PopupAlert from "./../common/popupAlert";
import jsfiledownload from "js-file-download";
//import {getUserCurrent,getUserCurrentbyArea} from './../../services/facescan';
import Renderreportcheck from "../report/renderreportcheck";
import Header from "../main/headerlist.jsx";
const Reportcheck = (props) => {
  const [Id, setId] = useState(props.match.params.id);
  const { currentBranch } = useContext(BranchContext);
  const [startDate, setStartDate] = useState(new Date());

  const [value, setValue] = useState(14);
  // const [total, setTotal] = useState(0);

  const [messageErros, setmessageErros] = useState({
    askAlert: {
      enable: false,
      message: "",
    },
  });

  const [reloading, setreloading] = useState(true);
  const [showonscroll, setshowonscroll] = useState(false);
  const [onprocess, setonprocess] = useState(false);
  const [pageSize, setPageSize] = useState(30);
  const [statusid, setstatusid] = useState(0);
  const [hasMore, setHasMore] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [loading, setloading] = useState(true);
  const [error, setError] = useState(false);
  const [reportlist, setreporlist] = useState([]);
  const [reportgroup, setreportgroup] = useState([]);
  const [userlist, setuserlist] = useState([]);
  const [locationlist, setlocationlist] = useState([]);
  const [zonearea, setzonearea] = useState([]);
  const [itemlist, setitemlist] = useState([]);
  const [grouplist, setgrouplist] = useState([]);
  const [reportId, setreportId] = useState(2);
  const [yearlist, setyearlist] = useState([]);
  const [monthlist, setmonthlist] = useState([]);
  const [yearid, setyearid] = useState(0);
  const [userid, setuserid] = useState(0);
  const [groupid, setgroupid] = useState(0);
  const [itemid, setitemid] = useState(0);
  const [locationid, setlocationid] = useState(0);
  const [zoneid, setzoneid] = useState(0);
  const [vLoad, setvLoad] = useState(false);
  const [month, setmonth] = useState(0);
  const [isDownload, setisDownload] = useState(true);
  const [datalist, setdatalist] = useState([]);
  const [search, setSearch] = useState("");
  const [typeresult, settyperesult] = useState(0);
  const [total, settotal] = useState(0);
  // const [statusid, setstatusid] = useState(0);
  const [resultlist, setresultlist] = useState([
    { _id: 0, name: "ทั้งหมด", classname: "btn btn-primary" },
    { _id: 1, name: "ตรวจแล้ว", classname: "btn btn-outline-dark" },
    { _id: 2, name: "ยังไม่ตรวจ", classname: "btn btn-outline-dark" },
  ]);
  // const [confirmsearch, setconfirmsearch] = useState("");
  const [refresh, setrefresh] = useState(new Date());
  const downloadReport = async () => {
    try {
      const output = await toexcelreportcheck(
        yearid,
        month,
        locationid,
        zoneid,
        groupid,statusid
      );

      const { data: result, headers } = output;
      setisDownload(false);
      if (result.status === "error") {
        toast.error(result.message);
      } else {
        if (headers["x-suggested-filename"] === "nodata") {
          toast.error("No Report");
        } else {
          jsfiledownload(
            result,
            headers["x-suggested-filename"] || `report.xlsx`
          );
        }
      }
      // } else {
      //   toast.error("Invalid Download Info")
      // }
    } catch (err) {
      toast.error("ผิดพลาด " + err.message);
    }
  };

  useEffect(() => {
    setreporlist([]);
  }, [yearid, month, locationid, zoneid, groupid, pageSize,statusid]);
  useEffect(() => {
    if (!currentBranch) return;
    if (yearid == 0) return;
    if (month == 0) return;
    if (locationid == 0) return;

    const loadData = async () => {
      const { data: result } = await getreportcheck(
        yearid,
        month,
        locationid,
        zoneid,
        groupid,pageSize, pageNumber,statusid
      );

      if (result.status === "success") {
        settotal(result.total.total)
        setreporlist((prevData) => {
          return [...new Set([...prevData, ...result.data.list])];
        });
        setHasMore(result.data.list.length > pageSize - 1);

        setloading(false);
        setreloading(false);
      } else if (
        result.status === "error" &&
        result.message === "invalid token"
      ) {
        // const urlGoBack = "logout";
        // setTimeout(props.history.replace(urlGoBack), 1000);
      }
    };

    loadData();
  }, [yearid, month, locationid, zoneid, groupid, pageSize, pageNumber,statusid]);

  useEffect(() => {
    if (!currentBranch) return;

    const loadData = async () => {
      const { data: result } = await GetYear();
      //console.log(result)
      if (result.status === "success") {
        setyearlist(result.data.list);
        // console.log("yl"+result);
      } else if (
        result.status === "error" &&
        result.message === "invalid token"
      ) {
        const urlGoBack = "logout";
        setTimeout(props.history.replace(urlGoBack), 1000);
      }
    };

    loadData();
  }, [currentBranch]);

  useEffect(() => {
    if (!currentBranch) return;

    const loadData = async () => {
      const result = await getMonth();

      if (result) {
        setmonthlist(result);
      }
    };
    loadData();
  }, [currentBranch]);

  useEffect(() => {
    if (!currentBranch) return;

    const loadData = async () => {
      const { data: result } = await getProductgroup();

      if (result) {
        setgrouplist(result);
      }
    };
    loadData();
  }, [currentBranch]);

  useEffect(() => {
    if (!currentBranch) return;

    const loadData = async () => {
      const { data: result } = await GetLocationAll();

      if (result.status === "success") {
        setlocationlist(result.data.list);
      }
    };
    loadData();
  }, [currentBranch]);

  useEffect(() => {
    if (!currentBranch) return;

    const loadData = async () => {
      const { data: result } = await getAreaZoneSelect(locationid);

      if (result.status === "success") {
        setzonearea(result.data.list);
      }
    };
    loadData();
  }, [currentBranch, locationid]);

  useEffect(() => {
    if (!currentBranch) return;

    const loadData = async () => {
      const { data: result } = await getItems(locationid, groupid);

      if (result) {
        setitemlist(result);
      }
    };
    loadData();
  }, [currentBranch, locationid, groupid]);

  const handleChangeSelect = ({ name, item, classname }) => {
 
    const clear = [...resultlist];
    const index1 = clear.findIndex((x) => x.classname === "btn btn-primary");
    if (index1 > -1) {
      clear[index1].classname = "btn btn-outline-dark";
      setresultlist(clear);
    }
    const subobject = {
      _id: item,
      name: name,
      classname: "btn btn-primary",
    };
    const sub = [...resultlist];
    const index = sub.findIndex((x) => x._id === item);
    sub[index] = subobject;
    setresultlist(sub);
    setstatusid(item)
    // setchkmy(item);
    setPageNumber(1);
  };

  const loadData = async () => {
    if (!currentBranch) return;
    const { data: result } = await getreportcheck(
      yearid,
      month,
      locationid,
      zoneid,
      groupid,
      pageSize,
      pageNumber,statusid
    );

    if (result.status === "success") {
      setreporlist((prevData) => {
        return [...new Set([...prevData, ...result.data.list])];
      });
      setHasMore(result.data.list.length > pageSize - 1);

      setloading(false);
      setreloading(false);

      // setreporlist(result.data.list);
      // setreporlist(result);
    }
  };

  useEffect(() => {
    if (!currentBranch) return;
    const loadData = async () => {
      const { data: result } = await getReportgroup();
      if (result) {
        setreportgroup(result);
      }
    };
    loadData();
  }, [currentBranch]);

  const handleyearChange = (event) => {
    setPageNumber(1);
    setyearid(event.currentTarget.value);
  };
  const handlemonthChange = (event) => {
    setPageNumber(1);
    setmonth(event.currentTarget.value);
  };

  const handleLocationIdChange = (event) => {
    setPageNumber(1);
    setlocationid(event.currentTarget.value);
  };

  const handleZoneidChange = (event) => {
    setPageNumber(1);
    setzoneid(event.currentTarget.value);
  };
  const handleGroupIdChange = (event) => {
    // setPageNumber(1);
    setgroupid(event.currentTarget.value);
  };
  const handlertyperesult = (e) => {
    // setPageNumber(1);
 
    // settyperesult(e.currentTarget.value);
  };

  const handleonClick = (event) => {
    // console.log(yearid,month);
    if (yearid === 0) {
      setmessageErros({
        askAlert: {
          enable: true,
          message: "ยังไม่ระบุปี กรุณาระบุก่อนค่ะ",
        },
      });
      return;
    } else if (month === 0) {
      setmessageErros({
        askAlert: {
          enable: true,
          message: "ยังไม่ระบุเดือน กรุณาระบุก่อนค่ะ",
        },
      });
      return;
    } else if (locationid === 0) {
      setmessageErros({
        askAlert: {
          enable: true,
          message: "ยังไม่ระบุพื้นที่ กรุณาระบุก่อนค่ะ",
        },
      });
      return;
    }
    setPageSize(1);
    loadData();
  };
  const handlePopupAlertClick = () => {
    setmessageErros({ askAlert: { enable: false, message: "" } });
  };

  // console.log("reportlist", reportlist);
  const observer = useRef();
  const lastBookElementRef = useCallback(
    (node) => {
      if (node && node.offsetTop > 0) {
        // setshowonscroll(true);
      }
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPageNumber((prevPageNumber) => prevPageNumber + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore]
  );
  const refreshdis = () => {
    setrefresh(new Date());
    setPageNumber(1);
  };
  if (!currentBranch) {
    return <></>;
  }
  return (
    <div className="  ">
      <PopupAlert
        isOpen={messageErros.askAlert.enable}
        onOk={handlePopupAlertClick}
        message={messageErros.askAlert.message}
      />
      <div className=" d-flex justify-content-center bg-info">
        <span
          className="badge-pill text-light p-2 px-3"
          style={{ fontSize: "25px" }}
        >
          รายงานพร้อมรูปถ่าย
        </span>
      </div>
      <div className="row justify-content-center mt-3">
        <div className="col-lg-2   col-sm-4 col-xs-8">
          <div className="form-group ">
            <Select
              label="ปี"
              data={yearlist}
              value={yearid}
              textProperty="name"
              valueProperty="_id"
              onChange={handleyearChange}
            />
          </div>
        </div>
        <div className="col-lg-2   col-sm-4 col-xs-8">
          <div className="form-group">
            <Select
              label="เดือน"
              data={monthlist}
              value={month}
              textProperty="name"
              valueProperty="_id"
              onChange={handlemonthChange}
            />
          </div>
        </div>
        <div className="col-lg-2   col-sm-4 col-xs-8">
          <div className="form-group">
            <Select
              label="พื้นที่"
              data={locationlist}
              value={locationid}
              textProperty="name"
              valueProperty="_id"
              onChange={handleLocationIdChange}
            />
          </div>
        </div>
        <div className="col-lg-2   col-sm-4 col-xs-8">
          <div className="form-group">
            <Select
              label="พื้นที่โซน"
              data={zonearea}
              value={zoneid}
              textProperty="name"
              valueProperty="_id"
              onChange={handleZoneidChange}
            />
          </div>
        </div>
        <div className="col-lg-2   col-sm-4 col-xs-8">
          <div className="form-group">
            <Select
              label="ประเภท"
              data={grouplist}
              value={groupid}
              textProperty="name"
              valueProperty="_id"
              onChange={handleGroupIdChange}
            />
          </div>
        </div>
      </div>
      {/* <div className="row  mx-4 btn-group" role="group" aria-label="Basic outlined example"onClick={handlertyperesult(0)}>
 <button type="button" className="btn btn-outline-primary"  value={0}> ทั้งหมด </button>
  <button type="button" className="btn btn-outline-primary"onClick={handlertyperesult(1)} value={1}>ตรวจแล้ว</button>
  <button type="button" className="btn btn-outline-primary"onClick={handlertyperesult(2)} value={2}>ยังไม่ตรวจ</button>
</div> */}

<div className="col-auto ">
              {/* <i>
                รายการอนุมัติ <span className="label label-default"></span>
              </i> */}
              <div className="mt-1">
                <Header
                  list={resultlist}
                  onChange={handleChangeSelect}
                  disabled={loading}
                  
                />
              </div>
            </div>

      <div className="row my-2 m-2  ">
        {/* <div className="col-auto ">
          <button
            className="btn btn-primary  "
            onClick={handleonClick}
            style={{ fontSize: 15 }}
          >
            ค้นหา
          </button>
        </div> */}

        <div className="col-auto">
          <button
            onClick={downloadReport}
            disabled={reportId === 0 || reportId === "0" ? true : false}
            className="btn btn-success "
            style={{ fontSize: 13 }}
          >
            Download To Excel
          </button>
        </div>
       
      </div>
      <div className="text-success m-2">
      รายการทั้งหมด {total} / {reportlist.length} รายการ
      </div>
    
      <div>
        <ScrollToTop />
      </div>

      <Renderreportcheck
        list={reportlist}
        lastBookElementRef={lastBookElementRef}
      />
      {/* <Renderreport list={reportlist} /> */}
    </div>
  );
};

export default Reportcheck;
